import { UserInformationRow } from '../UserInformationRow';
import { UserInformationPanelStyled } from './UserInformationPanel.styles';

interface UserInformationPanelProps {
  users: {
    name: string;
    description: string;
    badgeText: string;
    id: number;
    isRowEnabled?: boolean;
  }[];
  badgeWidth?: string;
  onUserSelected?: (id: number) => void;
}

export const UserInformationPanel = ({
  users,
  badgeWidth,
  onUserSelected,
}: UserInformationPanelProps) => (
  <UserInformationPanelStyled>
    <tbody>
      {users.map((user, index) => (
        <UserInformationRow
          isRowEnabled={user.isRowEnabled}
          onClick={
            user.isRowEnabled ? () => onUserSelected?.(user.id) : undefined
          }
          key={user.id}
          {...user}
          badgeWidth={badgeWidth}
          data-testid={`user-information-row-${index}`}
        />
      ))}
    </tbody>
  </UserInformationPanelStyled>
);
